import { render, staticRenderFns } from "./DebugPage.vue?vue&type=template&id=2f8788ed&"
import script from "./DebugPage.vue?vue&type=script&lang=js&"
export * from "./DebugPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports